module.exports = __webpack_public_path__ + "img/text.7966457d.png";